/**
 * @generated SignedSource<<007d806df4ba3b95d1db869a90dd3227>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserStatus = "ACTIVE" | "APPEAL" | "BANNED" | "BANNED_PERMANENT" | "INACTIVE" | "PENDING" | "SCHEDULED_FOR_DELETION" | "%future added value";
export type SearchProfileScreenQuery$variables = {
  profileId: any;
};
export type SearchProfileScreenQuery$data = {
  readonly profile: {
    readonly rowId: any;
    readonly user: {
      readonly status: UserStatus;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"SearchProfileView_profile">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"SearchProfileView_query">;
};
export type SearchProfileScreenQuery = {
  response: SearchProfileScreenQuery$data;
  variables: SearchProfileScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "profileId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "rowId",
    "variableName": "profileId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "type": {
        "equalTo": "PROFILE"
      }
    }
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "StorageObject",
  "kind": "LinkedField",
  "name": "storageObject",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blurhash",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bucket",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = [
  (v5/*:: as any*/),
  (v4/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SearchProfileScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Profile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SearchProfileView_profile"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "SearchProfileView_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "SearchProfileScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Profile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserDeetConnection",
                "kind": "LinkedField",
                "name": "userDeets",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserDeet",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deetId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "other",
                        "storageKey": null
                      },
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": [
                      "SEQUENCE_ASC"
                    ]
                  }
                ],
                "concreteType": "UserPromptConnection",
                "kind": "LinkedField",
                "name": "userPrompts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserPrompt",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "answer",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Prompt",
                        "kind": "LinkedField",
                        "name": "prompt",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "question",
                            "storageKey": null
                          },
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "userPrompts(orderBy:[\"SEQUENCE_ASC\"])"
              }
            ],
            "storageKey": null
          },
          (v5/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "age",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "closestCity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "distanceInKilometers",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "distanceInMiles",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "instagram",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isVerified",
            "storageKey": null
          },
          {
            "alias": "profilePhotos",
            "args": (v6/*:: as any*/),
            "concreteType": "PhotoConnection",
            "kind": "LinkedField",
            "name": "photos",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PhotoEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Photo",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sequence",
                        "storageKey": null
                      },
                      (v7/*:: as any*/),
                      (v4/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__id",
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": "photos(filter:{\"type\":{\"equalTo\":\"PROFILE\"}},first:10)"
          },
          {
            "alias": "profilePhotos",
            "args": (v6/*:: as any*/),
            "filters": [
              "filter"
            ],
            "handle": "connection",
            "key": "useProfilePhotos_profile_profilePhotos",
            "kind": "LinkedHandle",
            "name": "photos"
          },
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Photo",
            "kind": "LinkedField",
            "name": "headshot",
            "plural": false,
            "selections": [
              (v7/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ActivityConnection",
            "kind": "LinkedField",
            "name": "activities",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Activity",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v8/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BeliefSystem",
            "kind": "LinkedField",
            "name": "beliefSystem",
            "plural": false,
            "selections": (v8/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "biography",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ChildrenPreference",
            "kind": "LinkedField",
            "name": "childrenPreference",
            "plural": false,
            "selections": (v8/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DeetConnection",
            "kind": "LinkedField",
            "name": "deets",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Deet",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*:: as any*/),
                  (v5/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOther",
                    "storageKey": null
                  },
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EducationLevel",
            "kind": "LinkedField",
            "name": "educationLevel",
            "plural": false,
            "selections": (v8/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Gender",
            "kind": "LinkedField",
            "name": "gender",
            "plural": false,
            "selections": (v8/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "genderOther",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "heightCm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "heightFt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "heightIn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "occupation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PoliticalView",
            "kind": "LinkedField",
            "name": "politicalView",
            "plural": false,
            "selections": (v8/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Pronoun",
            "kind": "LinkedField",
            "name": "pronoun",
            "plural": false,
            "selections": (v8/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RelationshipTypeConnection",
            "kind": "LinkedField",
            "name": "relationshipInterests",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RelationshipType",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v8/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "school",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VaccinationStatus",
            "kind": "LinkedField",
            "name": "vaccinationStatus",
            "plural": false,
            "selections": (v8/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "verificationRequested",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nextSparkRefillAt",
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sparkBalance",
            "storageKey": null
          },
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMetricSystem",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7d50d397b060a9921a43b68252c9e8a7",
    "id": null,
    "metadata": {},
    "name": "SearchProfileScreenQuery",
    "operationKind": "query",
    "text": "query SearchProfileScreenQuery(\n  $profileId: UUID!\n) {\n  profile(rowId: $profileId) {\n    rowId\n    user {\n      status\n      id\n    }\n    ...SearchProfileView_profile\n    id\n  }\n  ...SearchProfileView_query\n}\n\nfragment ProfileAvatar_profile on Profile {\n  headshot {\n    storageObject {\n      blurhash\n      bucket\n      key\n    }\n    id\n  }\n  name\n}\n\nfragment ProfileBlockButton_profile on Profile {\n  name\n  userId\n}\n\nfragment ProfileCard_profile on Profile {\n  age\n  closestCity\n  distanceInKilometers\n  distanceInMiles\n  instagram\n  isVerified\n  name\n  rowId\n  userId\n  ...ProfileVerifiedBadge_profile\n  ...useProfilePhotos_profile\n}\n\nfragment ProfileCard_query on Query {\n  currentUser {\n    isMetricSystem\n    rowId\n    id\n  }\n}\n\nfragment ProfileHeaderTitle_profile on Profile {\n  age\n  closestCity\n  name\n  isVerified\n  ...ProfileAvatar_profile\n}\n\nfragment ProfileInfo_profile on Profile {\n  activities {\n    nodes {\n      name\n      id\n    }\n  }\n  age\n  beliefSystem {\n    name\n    id\n  }\n  biography\n  childrenPreference {\n    name\n    id\n  }\n  closestCity\n  deets {\n    nodes {\n      rowId\n      name\n      isOther\n      id\n    }\n  }\n  educationLevel {\n    name\n    id\n  }\n  gender {\n    name\n    id\n  }\n  genderOther\n  heightCm\n  heightFt\n  heightIn\n  occupation\n  politicalView {\n    name\n    id\n  }\n  pronoun {\n    name\n    id\n  }\n  relationshipInterests {\n    nodes {\n      name\n      id\n    }\n  }\n  school\n  userId\n  user {\n    userDeets {\n      nodes {\n        deetId\n        other\n        id\n      }\n    }\n    userPrompts(orderBy: [SEQUENCE_ASC]) {\n      nodes {\n        answer\n        prompt {\n          question\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n  vaccinationStatus {\n    name\n    id\n  }\n}\n\nfragment ProfileInfo_query on Query {\n  currentUser {\n    isMetricSystem\n    id\n  }\n}\n\nfragment ProfileLikeBottomSheet_profile on Profile {\n  name\n}\n\nfragment ProfileReportButton_profile on Profile {\n  name\n  userId\n}\n\nfragment ProfileVerificationButton_profile on Profile {\n  isVerified\n  name\n  userId\n  verificationRequested\n}\n\nfragment ProfileVerifiedBadge_profile on Profile {\n  isVerified\n}\n\nfragment SearchProfileView_profile on Profile {\n  name\n  rowId\n  userId\n  ...ProfileBlockButton_profile\n  ...ProfileCard_profile\n  ...ProfileHeaderTitle_profile\n  ...ProfileLikeBottomSheet_profile\n  ...ProfileInfo_profile\n  ...ProfileReportButton_profile\n  ...ProfileVerificationButton_profile\n  ...ProfileVerifiedBadge_profile\n}\n\nfragment SearchProfileView_query on Query {\n  currentUser {\n    nextSparkRefillAt\n    rowId\n    sparkBalance\n    id\n  }\n  ...ProfileCard_query\n  ...ProfileInfo_query\n}\n\nfragment useProfilePhotos_profile on Profile {\n  profilePhotos: photos(first: 10, filter: {type: {equalTo: PROFILE}}) {\n    edges {\n      cursor\n      node {\n        description\n        rowId\n        sequence\n        storageObject {\n          blurhash\n          bucket\n          key\n        }\n        id\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "ce0d7c1c746d3c15f412c465d32309ef";

export default node;
